export class LogInDto {
  username: string;
  password: string;

  constructor() {
    this.username = null;
    this.password = null;
  }
}
